import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightDoorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearRightDoor(props: RearRightDoorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Right Door"
      width={318}
      height={92}
      viewBox="0 0 318 92"
      position={{top: -5, right: 321}}
    >
      {/* Door body (evenodd composite) */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97 91C126 91 193.063 86.5209 233 75C278.063 62.0001 317 53.1107 317 35C317 17 284 6 257 6H2C3.33333 9.11325 7 17.3765 11 24.3047C15 31.2329 15.3333 37.1914 15 39.3047L34 91H97ZM46.0771 85L39 39L200.915 39.585L206.046 74.2197C156.985 83.4237 104.673 84.9985 46.084 85H46.0771ZM206.928 39.6064L287 39.8955C287 48.8954 281.967 52.9034 261 60C244.957 65.4298 228.671 69.702 212.021 73.0576L206.928 39.6064Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Vent glass overlay */}
      <path
        opacity="0.8"
        d="M206.927 39.6062L212.02 73.058C228.671 69.7023 244.957 65.4299 261 60C281.968 52.9033 287 48.8953 287 39.8953L206.927 39.6062Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Door glass overlay */}
      <path
        opacity="0.8"
        d="M200.915 39.5845L206.045 74.2202C156.984 83.4242 104.673 84.9985 46.0844 85H46.0769L39 39L200.915 39.5845Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Outer stroke */}
      <path
        d="M233 75C193.063 86.5209 126 91 97 91L53 91L34 91L15 39.3047C15.3333 37.1914 15 31.2329 11 24.3047C7 17.3765 3.33333 9.11325 2 6H257C284 6 317 17 317 35C317 53.1107 278.063 62.0001 233 75Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Pillar line */}
      <path
        d="M39 39L47 91"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Waist line */}
      <path
        d="M316 40L39 39H15"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Glass inner line */}
      <path
        d="M287 40C287 49 281.968 52.9033 261 60C196 82 127 85 46 85"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Vent pillar */}
      <path
        d="M212 73L207 40"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M206 74L201 40"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Belt line */}
      <path
        d="M13 27.6087C120.201 28.8042 226.843 28.2809 316 29.6957"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Door handle fill */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224 16C238.937 15.9997 258.853 14 256.861 11C250.119 0.843768 231.966 1 224 1C216.034 1 197.881 0.84377 191.139 11C189.147 14 209.062 15.9997 224 16ZM207 10C208.766 7.75684 211.491 6.00004 216 6H232C236.509 6.00005 239.234 7.75682 241 10H207Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Handle outline */}
      <path
        d="M256.862 11C250.119 0.843672 231.966 1.00014 224 1.00014C216.034 1.00014 197.881 0.843672 191.138 11C189.147 14 209.062 15.9997 224 16C238.937 15.9997 258.853 14 256.862 11Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Handle inner */}
      <path
        d="M243 15C242.667 12.3333 240 6 232 6C224 6 224 6 224 6C224 6 224 6 216 6C208 6 205.333 12.3333 205 15"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M207 10H241"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
